import React from 'react';
import { Box, Group, Radio, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';
import * as Styled from '../Plan/styled';
import { useBasicDownload } from './useBasicDownload';

export const BasicDownload = () => {
    const { selectedPlan, studioCatalog, handlePlanSelect } =
        useUpsellActionsContext();

    const { code, price, title } = useBasicDownload({
        studioCatalog,
    });

    const isChecked = selectedPlan === code;

    return (
        <Group.Item>
            <Box
                className={Styled.planWrapper}
                onClick={() => handlePlanSelect(code)}
            >
                <Box
                    className={Styled.innerWrapper}
                    style={{
                        backgroundColor: isChecked ? undefined : 'transparent',
                    }}
                >
                    <Group gap="xs" verticalAlign="middle" width="100%">
                        <Group.Item flexGrow="0" width="md" alignSelf="center">
                            <Radio
                                onChange={() => undefined}
                                isChecked={isChecked}
                                label=""
                                size="md"
                                padding="none"
                                pointerEvents="none"
                            />
                        </Group.Item>
                        <Group.Item
                            flexGrow={1}
                            textAlign="left"
                            alignSelf="center"
                        >
                            <Text fontWeight="bold">{title}</Text>
                        </Group.Item>
                        <Group.Item flexGrow="0">
                            <Box>
                                <Text textStyle="lead" fontWeight="bold">
                                    {price}
                                </Text>
                            </Box>
                        </Group.Item>
                    </Group>
                    <Group gap="xs" verticalAlign="middle" width="100%">
                        <Group.Item
                            flexGrow="0"
                            width="md"
                            alignSelf="center"
                        />
                        <Group.Item flexGrow={1} textAlign="left">
                            <Group direction="vertical" gap="xs">
                                <Group.Item>
                                    <Text
                                        color="text.medium"
                                        textStyle="body-sm"
                                    >
                                        <Trans>
                                            Available only for free samples
                                        </Trans>
                                    </Text>
                                </Group.Item>
                            </Group>
                        </Group.Item>
                    </Group>
                </Box>
            </Box>
        </Group.Item>
    );
};
